/* eslint-disable no-underscore-dangle */
import { AsyncStatusEnum } from 'src/researcher/types/common';
import { TemplateDocument, TemplateListAPIResponse } from 'src/researcher/types/api';

export type TemplateCardData = TemplateDocument & {
  creating: boolean;
  id: string;
};

export type TemplateCollection = Record<string, TemplateCardData>;

export type TemplateListStore = {
  query: string;
  skip: number;
  total: number;
  status: AsyncStatusEnum;
  templates: TemplateCollection;
  count: number;
  //   sort: SortByOrderBy;
};

type AddTemplateListStoreAction = {
  type: 'add_templates';
  payload: TemplateListAPIResponse;
};

type SetStatusTemplateListStoreAction = {
  type: 'set_status';
  payload: AsyncStatusEnum;
};

type LoadNextTemplateListStoreAction = {
  type: 'load_next';
};

type SelectedTemplateActionPayload = {
  id: string;
  creating: boolean;
};

type SelectedTemplatedAction = {
  type: 'selected_template';
  payload: SelectedTemplateActionPayload;
};

type ResetTemplateStoreAction = {
  type: 'reset';
};

export type TemplateListActions =
  | AddTemplateListStoreAction
  | SetStatusTemplateListStoreAction
  | SelectedTemplatedAction
  | ResetTemplateStoreAction
  | LoadNextTemplateListStoreAction;

export const addTemplateListStoreAction = (
  payload: TemplateListAPIResponse
): AddTemplateListStoreAction => ({ type: 'add_templates', payload });

export const loadNextTemplateListStoreAction = (): LoadNextTemplateListStoreAction => ({
  type: 'load_next',
});

export const setStatusTemplateListStoreAction = (
  status: AsyncStatusEnum
): SetStatusTemplateListStoreAction => ({
  type: 'set_status',
  payload: status,
});

export const selectedTemplateListStoreAction = (
  payload: SelectedTemplateActionPayload
): SelectedTemplatedAction => ({
  type: 'selected_template',
  payload,
});

export const resetTemplateListStoreAction = (): ResetTemplateStoreAction => ({
  type: 'reset',
});

const InitListStoreState: TemplateListStore = {
  query: '',
  skip: 0,
  total: 0,
  templates: {},
  count: 0,
  status: AsyncStatusEnum.PENDING,
};

const transformAPIToCardData = (template: TemplateDocument): TemplateCardData => ({
  ...template,
  id: template._id,
  creating: false,
});

const createTemplateCollection = (templates: TemplateDocument[] = []) =>
  templates?.map?.(transformAPIToCardData)?.reduce((obj: TemplateCollection, template) => {
    obj[template.id] = template;
    return obj;
  }, {} as TemplateCollection);

export function templateListStoreReducer(
  state: TemplateListStore = InitListStoreState,
  action: TemplateListActions
) {
  switch (action.type) {
    case 'add_templates': {
      return {
        ...state,
        templates: {
          ...state.templates,
          ...createTemplateCollection(action.payload.templates),
        },
        count: state.count + action.payload.templates?.length || 0,
        total: action.payload.total,
        status: AsyncStatusEnum.RESOLVE,
      };
    }
    case 'set_status': {
      return {
        ...state,
        status: action.payload,
      };
    }

    case 'load_next': {
      if (state.count < state.total && state.status === AsyncStatusEnum.RESOLVE) {
        return {
          ...state,
          status: AsyncStatusEnum.PENDING,
          skip: Math.min(state.count, state.total),
        };
      }
      return state;
    }

    // case 'set_creating': {
    //   const project = state.templates[action.payload.id];

    //   if (!project) {
    //     return state;
    //   }

    //   const newTemplates = { ...state.templates };

    //   newTemplates[action.payload.id] = {
    //     ...project,
    //     creating: action.payload.creating,
    //   };

    //   return {
    //     ...state,
    //     templates: newTemplates,
    //   };
    // }

    case 'reset': {
      return InitListStoreState;
    }

    default: {
      return state;
    }
  }
}
